
export const DigitsKeyboardAttrs = {
  inputmode: 'numeric'
}